export const AUTOFILL_NRIC = 'nric';
export const AUTOFILL_PASSPORT = 'passport';
export const AUTOFILL_MILITARY = 'military';
export const AUTOFILL_COMPANY = 'company';
export const AUTOFILL_ID_NUMBER = 'id_number';
export const AUTOFILL_PRESET = 'preset';
export const AUTOFILL_MSISDN = 'msisdn';
export const AUTOFILL_PRS = 'prs';

export const AUTOFILL_IDENTITY_TYPES = [
  { id: 1, name: 'nric' },
  { id: 2, name: 'passport' },
  { id: 3, name: 'military' },
  { id: 4, name: 'company' },
  { id: 5, name: 'id_number' },
  { id: 6, name: 'preset' },
];

export const CRM_SEARCH_FIELD_MAPPINGS = [
  {
    label: 'Kartu Tanda Penduduk',
    searchField: 'ktp',
  },
];



// WEBPACK FOOTER //
// ./src/constants/autofillTypes.js